<template>
  <div :class="[`item-form_${item.id}`, `label-on-${itemStyle.general.labelOn}`]" :style="style">
    <label
      v-if="item.type !== 'Button' && options.label"
      :for="options.name"
      :style="{ fontSize: `${itemStyle.general.labelSize}px`, color: `${itemStyle.general.labelColor}` }"
    >
      {{ $t(`label.${item.type}`) }}
      <sup v-if="options.required"> * </sup>
      <span v-else> {{ $t('optional') }} </span>
    </label>
    <component :is="reference" :item="item" :itemStyle="itemStyle[item.type]" />
  </div>
</template>

<script>
import FormItemMixin from '@/components/page-editor/widget/form/Mixin.js'

export default {
  name: 'FormItem',
  mixins: [FormItemMixin],
  i18nOptions: { keyPrefix: 'components.page-editor.widget.form' },
  computed: {
    reference() {
      return () => import(`@/components/page-editor/widget/form/${this.item.type}.vue`)
    },
    position() {
      return this.options.position[this.currentView]
    },
    size() {
      return this.options.size[this.currentView]
    },
    style() {
      return {
        order: this.position,
        margin: `${this.itemStyle.general.margin}px`,
        width: `calc(${(100 * this.size) / 12}% - ${this.itemStyle.general.margin * 2}px)`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
[class^='item-form_'] {
  display: flex;

  &.label-on-top {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;

    label {
      margin-bottom: 3px;
    }
  }
  &.label-on-side {
    align-items: center;
    justify-content: center;

    label {
      margin-right: 10px;
    }
  }
}
</style>
